import { SharpnessDisplay } from 'components';

export const baseSharpnessAccessor = (originalRow: any) => {
  return originalRow.baseSharpness;
};

export const BaseSharpnessCell = ({ value }: { value: any }) => {
  return <SharpnessDisplay sharpness={value} />;
};
